import { render, staticRenderFns } from "./PoiDetailStatus.vue?vue&type=template&id=485382ec"
import script from "./PoiDetailStatus.js?vue&type=script&lang=js&external"
export * from "./PoiDetailStatus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports